import { getDigitsFromString } from '@/utils/getDigitsFromString'
import { MinorsTermFormData } from '../components/MinorsTermModal/types'

class SaveMinorsGuardianData {
  toPersistence(data: MinorsTermFormData) {
    return {
      cpfResponsavel: getDigitsFromString(data?.guardianCpf),
      nomeResponsavel: data?.guardianName,
    }
  }
}

export default new SaveMinorsGuardianData()
